export const environment = {
  production: true,
  brand: 'base'
};
